import React from "react";
import './App.css';
import { Route, HashRouter } from 'react-router-dom';
import Home from './components/home/Home';
// import HomeTest from './components/HomeTest';
import { getMFERegisterEndpoint } from "./untils/NetHelper";
import Endpoints from "./untils/urlConstants";

function App() {


  (async () => {
    // get microApp list
    const registerEndpoints = await getMFERegisterEndpoint();
    Endpoints.initEndpoints(registerEndpoints);
  })();

  return (
    <HashRouter>
      {/* <Route exact path="/business-banking/portal" component={Home}></Route> */}
      {/* <Route path="/business-banking/portal2" component={HomeTest}></Route> */}
      <Route path="/" component={Home}></Route>
      {/* <Redirect from='/*' to="/business-banking/portal"></Redirect> */}
    </HashRouter>
  );
}

export default App;
